import submit from '../Services/submit'

export default async (values, dispatch) => {

  dispatch(submit(values))

}